import React, { useEffect } from 'react';
import CreateCourseWizard from '../../pages/createEndeavors/CreateCourseWizard';
import './CreateCourseModal.css';

/**
 * CreateCourseModal — full-screen modal wrapper around CreateCourseWizard.
 *
 * Props:
 *   open: boolean
 *   orgId: optional org id; when set, the wizard creates an org-owned course
 *          via OrgAdminApi.createOrgOwnedCourse instead of personal/shared.
 *   onClose(): called when user dismisses the modal (cancel or backdrop).
 *   onCreated(result): called after a successful creation with
 *          { endeavorId, endeavor }.
 */
export default function CreateCourseModal({ open, orgId = null, onClose, onCreated }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape' && typeof onClose === 'function') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const handleCreated = (result) => {
    if (typeof onCreated === 'function') onCreated(result);
    if (typeof onClose === 'function') onClose();
  };

  return (
    <div
      className="create-course-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="Create course"
      onClick={(e) => { if (e.target === e.currentTarget && typeof onClose === 'function') onClose(); }}
    >
      <div className="create-course-modal-inner">
        <CreateCourseWizard
          orgId={orgId}
          embedded
          onCreated={handleCreated}
          onCancel={onClose}
        />
      </div>
    </div>
  );
}
